'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _signUpModal = require('../actions/sign-up-modal');

var INITIAL_STATE = {
	isOpen: false,
	firstPageActive: false,
	patientSignUpActive: false,
	specialistSignUpActive: false,
	typePassword: true,
	agreeButtonActive: false,
	specialtyListActive: false,
	accountData: {
		account_type: '',
		attributes: {},
		display_name: '',
		name: '',
		notification_settings: false,
		password: ''
	},
	userData: {
		attributes: '',
		firstname: '',
		lastname: '',
		gender: '',
		birthdate: '00-xxx-0000',
		personal_email: '',
		personal_phone: '',
		title: ''
	},
	title: '',
	firstname: '',
	lastname: '',
	submitFailed: false,
	serverErrorMessage: '',
	patientSubmitSuccess: false,
	specialistSubmitSuccess: false,
	shouldSetBookingFlowAuthToken: false,
	bookingFlowAuthToken: '',
	bookingFlowAuthInfo: {}
};

var signUpModal = function signUpModal(state, action) {
	switch (action.type) {
		case _signUpModal.OPEN:
			return Object.assign({}, state, { isOpen: true, firstPageActive: true, backButtonVisible: true });
		case _signUpModal.BOOK_APPOINTMENT_SIGN_UP_SELECTED:
			return Object.assign({}, state, { isOpen: true, patientSignUpActive: true, backButtonVisible: false, accountData: _extends({}, state.accountData, { account_type: 'patient' }) });
		case _signUpModal.CLOSE:
			return Object.assign({}, state, INITIAL_STATE, { bookingFlowAuthToken: state.bookingFlowAuthToken, bookingFlowAuthInfo: _extends({}, state.bookingFlowAuthInfo) });
		case _signUpModal.BACK:
			return Object.assign({}, state, _extends({}, INITIAL_STATE, { isOpen: true, firstPageActive: true }));
		case _signUpModal.PATIENT_BUTTON_CLICK:
			return Object.assign({}, state, { firstPageActive: false, patientSignUpActive: true, accountData: _extends({}, state.accountData, { account_type: 'patient' }) });
		case _signUpModal.SPECIALIST_BUTTON_CLICK:
			return Object.assign({}, state, { firstPageActive: false, specialistSignUpActive: true, accountData: _extends({}, state.accountData, { account_type: 'specialist' }) });
		case _signUpModal.TOGGLE_SHOW_PASSWORD:
			return Object.assign({}, state, { typePassword: !state.typePassword });
		case _signUpModal.AGREE_BUTTON_CLICKED:
			return Object.assign({}, state, { agreeButtonActive: !state.agreeButtonActive, accountData: _extends({}, state.accountData, { notification_settings: !state.accountData.notification_settings }) });
		case _signUpModal.SET_SPECIALTY_LIST_ACTIVE:
			return Object.assign({}, state, { specialtyListActive: !state.specialtyListActive });
		case _signUpModal.SET_LIST_ITEM_ACTIVE:
			return Object.assign({}, state, { activeListItem: action.item, specialtyListActive: false });
		case _signUpModal.TITLE_CHANGE:
			{
				var title = action.title;
				return Object.assign({}, state, { title: title, accountData: _extends({}, state.accountData, { display_name: (title + ' ' + state.firstname + ' ' + state.lastname).trim() }), userData: _extends({}, state.userData, { title: title }) });
			}
		case _signUpModal.FIRST_NAME_CHANGE:
			{
				var firstname = action.name;
				return Object.assign({}, state, { firstname: firstname, accountData: _extends({}, state.accountData, { display_name: (state.title + ' ' + firstname + ' ' + state.lastname).trim() }), userData: _extends({}, state.userData, { firstname: firstname }) });
			}
		case _signUpModal.LAST_NAME_CHANGE:
			{
				var lastname = action.name;
				return Object.assign({}, state, { lastname: lastname, accountData: _extends({}, state.accountData, { display_name: (state.title + ' ' + state.firstname + ' ' + lastname).trim() }), userData: _extends({}, state.userData, { lastname: lastname }) });
			}
		case _signUpModal.EMAIL_CHANGE:
			return Object.assign({}, state, { accountData: _extends({}, state.accountData, { name: action.email }) });
		case _signUpModal.PASSWORD_CHANGE:
			return Object.assign({}, state, { accountData: _extends({}, state.accountData, { password: action.password }) });
		case _signUpModal.SEX_CHANGE:
			return Object.assign({}, state, { userData: _extends({}, state.userData, { gender: action.gender }) });
		case _signUpModal.BIRTHDATE_DAY_CHANGE:
			return Object.assign({}, state, { userData: _extends({}, state.userData, { birthdate: state.userData.birthdate.replace(/^\d{2}/, action.day.length === 1 ? '0' + action.day : action.day) }) });
		case _signUpModal.BIRTHDATE_MONTH_CHANGE:
			return Object.assign({}, state, { userData: _extends({}, state.userData, { birthdate: state.userData.birthdate.replace(/\b[a-zA-Z]{3}\b/, action.month) }) }); //eslint-disable-line
		case _signUpModal.BIRTHDATE_YEAR_CHANGE:
			return Object.assign({}, state, { userData: _extends({}, state.userData, { birthdate: state.userData.birthdate.replace(/\d{4}/, action.year) }) });
		case _signUpModal.PHONE_CHANGE:
			return Object.assign({}, state, { userData: _extends({}, state.userData, { personal_phone: action.phone }) });
		case _signUpModal.CREATE_ACCOUNT + '_RECEIVED':
			return Object.assign({}, state, { id: action.response.id, auth_token: action.response.auth_token });
		case _signUpModal.CREATE_ACCOUNT + '_FAILED':
			{
				var msg = action.errorData === 'duplicate key value violates unique constraint "t_account_name_key"' ? 'That email address is already in use!' : 'There seems to be an issue with our servers. Please try again later.';
				return Object.assign({}, state, { serverErrorMessage: msg });
			}
		case _signUpModal.PATIENT_CALL + '_RECEIVED':
			return Object.assign({}, state, { patientSignUpActive: false, patientSubmitSuccess: true });
		case _signUpModal.SPECIALIST_CALL + '_RECEIVED':
			return Object.assign({}, state, { specialistSignUpActive: false, specialistSubmitSuccess: true });
		case _signUpModal.VALIDATION_ERROR:
			return Object.assign({}, state, { submitFailed: true });
		// Below - janky hacks for booking flow auth. See also book appt modal, specialist page, and sign up modal.
		case _signUpModal.SET_SHOULD_SET_BOOKING_FLOW_AUTH:
			return Object.assign({}, state, { shouldSetBookingFlowAuthToken: action.should });
		case _signUpModal.SET_BOOKING_FLOW_AUTH_TOKEN:
			return Object.assign({}, state, { bookingFlowAuthToken: action.token });
		case _signUpModal.SET_BOOKING_FLOW_AUTH_INFO:
			return Object.assign({}, state, { bookingFlowAuthInfo: action.info });
		default:
			return state || INITIAL_STATE;
	}
};

exports.default = signUpModal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-global-redux/lib/reducers/sign-up-modal.js
// module id = 1691
// module chunks = 0